

let navigator;

export const setNavigate = (navigate) => {
  navigator = navigate;
};


export const navigate = (to, options) => {

  if (!navigator) {
    throw new Error('SEM FUNÇÃO DE ROTEAMENTO');
  }

  navigator(to, options);
};
